import * as types from "./ActionTypes";

/** A check of the maintenance status endpoint answered. */
export const maintenanceStatusReceived = (status, receivedAt = Date.now()) => ({
  type: types.MAINTENANCE_STATUS_RECEIVED,
  payload: status || {},
  receivedAt,
});

/** An API call was refused with the maintenance 503. */
export const maintenanceDetected = (body, receivedAt = Date.now()) => ({
  type: types.MAINTENANCE_DETECTED,
  payload: body || {},
  receivedAt,
});
